var _desc, _defs, _rect, _rect2, _text, _line, _circle, _circle2, _rect3, _rect4, _circle3, _circle4, _image, _image2, _g, _path, _circle5, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndusTpcRelationshipMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 390 382",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Mobile AndUs and Performance Centre relationship") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "AndUs is the technology provider within the Performance Centre Group.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bridge",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#087CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF2775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB51B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "blueGlow"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#087CFF",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "goldGlow"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFB51B",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB51B",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 388,
    height: 380,
    rx: 22,
    fill: "#FFFFFF",
    stroke: "#D9E4F3",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 364,
    height: 356,
    rx: 16,
    fill: "none",
    stroke: "#E9EFF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 25,
    y: 45,
    fill: "#07172F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 760,
    letterSpacing: 2.3
  }, "ONE PERFORMANCE ECOSYSTEM")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 61,
    x2: 367,
    y2: 61,
    stroke: "#E0E8F3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 161,
    r: 108,
    fill: "url(#blueGlow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 161,
    r: 108,
    fill: "url(#goldGlow)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 83,
    width: 159,
    height: 190,
    rx: 17,
    fill: "#FFFFFF",
    stroke: "#CFE0F4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 83,
    width: 159,
    height: 190,
    rx: 17,
    fill: "#FFF9EE",
    stroke: "#F1DFC0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 161,
    r: 56,
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.17
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 161,
    r: 56,
    fill: "none",
    stroke: "#FFB51B",
    strokeOpacity: 0.22
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 47,
    y: 116,
    width: 106,
    height: 56,
    preserveAspectRatio: "xMidYMid meet",
    xlinkHref: "andus-logo.png",
    href: "andus-logo.png"
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    x: 232,
    y: 117,
    width: 116,
    height: 49,
    preserveAspectRatio: "xMidYMid meet",
    xlinkHref: "tpc-performance-centre-logo.png",
    href: "tpc-performance-centre-logo.png"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Inter, Arial, sans-serif",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 199,
    fill: "#07172F",
    fontSize: 12.5,
    fontWeight: 760
  }, "ANDUS"), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 218,
    fill: "#52637B",
    fontSize: 9.5
  }, "Intelligence Systems"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 237,
    width: 104,
    height: 23,
    rx: 11.5,
    fill: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 252.5,
    fill: "#087CFF",
    fontSize: 7.5,
    fontWeight: 760,
    letterSpacing: 0.55
  }, "TECHNOLOGY PROVIDER"), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 199,
    fill: "#07172F",
    fontSize: 10.5,
    fontWeight: 760
  }, "PERFORMANCE CENTRE"), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 218,
    fill: "#52637B",
    fontSize: 9.5
  }, "TPC Group"), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 237,
    width: 96,
    height: 23,
    rx: 11.5,
    fill: "#FFF0D4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 252.5,
    fill: "#C87500",
    fontSize: 7.5,
    fontWeight: 760,
    letterSpacing: 0.55
  }, "GROUP PLATFORM"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 176h30",
    stroke: "url(#bridge)",
    strokeWidth: 2.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 176,
    r: 21,
    fill: "#FFFFFF",
    stroke: "url(#bridge)",
    strokeWidth: 1.6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Inter, Arial, sans-serif",
    textAnchor: "middle",
    fill: "#07172F",
    fontSize: 6.7,
    fontWeight: 760,
    letterSpacing: 0.5
  }, /*#__PURE__*/React.createElement("text", {
    x: 195,
    y: 173
  }, "PART"), /*#__PURE__*/React.createElement("text", {
    x: 195,
    y: 182
  }, "OF"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Inter, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 298,
    width: 348,
    height: 58,
    rx: 13,
    fill: "#F7FAFE",
    stroke: "#E2EAF5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 327,
    r: 15,
    fill: "#FFFFFF",
    stroke: "#D7E6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 327h14M48 320v14",
    stroke: "url(#bridge)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 71,
    y: 324,
    fill: "#087CFF",
    fontSize: 8.5,
    fontWeight: 760,
    letterSpacing: 1.25
  }, "SHARED PURPOSE"), /*#__PURE__*/React.createElement("text", {
    x: 71,
    y: 341,
    fill: "#07172F",
    fontSize: 10.5,
    fontWeight: 700
  }, "Technology that advances real performance."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndusTpcRelationshipMobile);
export default __webpack_public_path__ + "static/media/andus-tpc-relationship-mobile.3e9f42155945cf6d69d47a406585f0ee.svg";
export { ForwardRef as ReactComponent };